import { Box, Button, Dialog, Portal, Stack } from '@chakra-ui/react'
import { Field, Formik } from 'formik'
import { useEffect } from 'react'
import { Form } from 'uikit'
import { SwitchForm } from 'uikit/FormStateComponents'
import { useEkengSettingsFetch } from './services/useEkengSettingsFetch'
import { useEkengSettingsUpdate } from './services/useEkengSettingsUpdate'

export const EkengSettings = ({ isOpen, onClose }) => {
  const { refetch: getEkengSettings, isPending: isLoadingFetch, data } = useEkengSettingsFetch()
  const { mutate: updateEkengSettings, isPending: isLoadingUpdate } = useEkengSettingsUpdate()

  useEffect(() => {
    if (isOpen) {
      getEkengSettings()
    }
  }, [isOpen])

  const handleForm = (values) => {
    const dataRequest = {
      ...data,
      automaticErrorHandling: values.automaticErrorHandling,
    }
    updateEkengSettings(dataRequest, {
      onSuccess: () => {
        onClose()
      }
    })
  }

  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>Режим ЕКЕНГ</Dialog.Title>
              <Dialog.CloseTrigger />
            </Dialog.Header>
            <Dialog.Body>
              <Formik
                enableReinitialize
                initialValues={{
                  automaticErrorHandling: data?.automaticErrorHandling,
                }}
                onSubmit={handleForm}
              >
                {(props) => (
                  <Form onSubmit={props.handleSubmit}>
                    <Stack gap={4}>
                      <Field
                        name="automaticErrorHandling"
                        label="Автоматический режим"
                        component={SwitchForm}
                      />
                    </Stack>
                    <Box pt="30px">
                      <Button
                        type="submit"
                        colorPalette="orange"
                        loading={isLoadingUpdate || isLoadingFetch}
                      >
                        Сохранить
                      </Button>
                    </Box>
                  </Form>
                )}
              </Formik>
            </Dialog.Body>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
